import * as React from 'react';

export default ({ color = '#B5BFD2', size = 24, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 1024 1024"
    aria-hidden="true"
    data-icon="pause-circle"
    fill={color}
    {...rest}
  >
    <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64m0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372m-88-532h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8m224 0h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8" />
  </svg>
);
